/* Khong hieu sao phai cho menu ra ngoai file rieng thi moi o duoi appbar */
import { DirectionsBoat, LegendToggleOutlined, TableView } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import * as React from "react";

const useStyles = makeStyles((theme) => ({
  menuText: {
    color: "#FFF",
  },
  menuIcon: {
    color: "#FFF",
  },
}));
const englishUI = true;
const menuTitles = englishUI
  ? {
    DanhMuc: "List",
    Codes: "Code",
    Ships: "Ship",
    Contractor: "Contractor",
    Budget: "Budget plan",
    FileTemplate: "File template",
    ShipYearBudget: "Ship year budget",
  }
  : {
    DanhMuc: "Danh mục",
    Codes: "Mã code",
    Ships: "Tàu",
    Contractor: "Nhà thầu",
    Budget: "Kế hoạch chi phí năm",
    FileTemplate: "File mẫu",
    ShipYearBudget: "Ngân sách tàu/năm"
  };
export default function MenuDanhMuc(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const hashShip = global.hasRoles("R11");
  const hasCode = global.hasRoles("R13");
  const hasContractor = global.hasRoles("R14");
  const hasBudgetPlan = global.hasRoles("R15");
  const hasFileTemplate = global.hasRoles("R16");
  const hasShipYearBudget = global.hasRoles("R17");

  return (
    <>
      <IconButton
        id="basic-button"
        sx={{ marginLeft: "auto" }}
        size="large"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {open ? (
          <ArrowDropDownIcon className={classes.menuIcon} />
        ) : (
          <ArrowRightIcon className={classes.menuIcon} />
        )}
        <Typography className={classes.menuText} variant="h6" noWrap>
          {menuTitles.DanhMuc}
        </Typography>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {hasCode ? (
          <>
            <MenuItem
              disabled={!hasCode}
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "DM_Codes",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <DirectionsBoat fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.Codes}</ListItemText>
            </MenuItem>
            <Divider />
          </>
        ) : null}
        {hashShip ? (
          <>
            <MenuItem
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "DM_Ship",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <DirectionsBoat fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.Ships}</ListItemText>
            </MenuItem>
            <Divider />
          </>
        ) : null}
        {hasContractor ? (
          <>
            <MenuItem
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "DM_CongTy",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <DirectionsBoat fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.Contractor}</ListItemText>
            </MenuItem>
            <Divider />
          </>
        ) : null}

        {hasBudgetPlan ? (
          <>
            <MenuItem
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "CP_KeHoachNam",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <LegendToggleOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.Budget}</ListItemText>
            </MenuItem>
            <Divider />
          </>
        ) : null}
        {hasFileTemplate ? (
          <>
            <MenuItem
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "CP_FileTemplate",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <TableView fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.FileTemplate}</ListItemText>
            </MenuItem>
            <Divider />
          </>
        ) : null}
        {hasShipYearBudget ? (
          <>
            <MenuItem
              onClick={() => {
                if (props.onClick) {
                  props.onClick({
                    name: "CP_ShipYearBudget",
                    title: "",
                  });
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <TableView fontSize="small" />
              </ListItemIcon>
              <ListItemText>{menuTitles.ShipYearBudget}</ListItemText>
            </MenuItem>
          </>
        ) : null}
      </Menu>
    </>
  );
}
